import { err, ok } from 'neverthrow'
import { evaluatorErrorWithNode } from '../../scriptevaluator/EvaluatorError'
import { functionNodeTypes, HelperFunction } from '../FunctionTypes'

function parseBPSystolic(value: string | null): number | null {
	if (value === null || value === '') return null
	const parts = value.split('/')
	if (parts.length !== 2) return null
	const sbp = Number(parts[0])
	return isNaN(sbp) ? null : sbp
}
function parseBPDiastolic(value: string | null): number | null {
	if (value === null || value === '') return null
	const parts = value.split('/')
	if (parts.length !== 2) return null
	const dbp = Number(parts[1])
	return isNaN(dbp) ? null : dbp
}
export const BPSystolicFunction: HelperFunction = {
	tokenName: 'BP_SYSTOLIC',
	nodeType: functionNodeTypes.BPSystolic,
	evaluate(node, evaluateExpr) {
		if (node.arguments.length !== 1) {
			return err(evaluatorErrorWithNode('Systolic BP function expects exactly one argument', node))
		}
		const result = evaluateExpr(node.arguments[0])
		if (result.isErr()) return err(result.error)
		if (typeof result.value !== 'string' && result.value !== null) return ok(null)
		return ok(parseBPSystolic(result.value as string | null))
	}
}
export const BPDiastolicFunction: HelperFunction = {
	tokenName: 'BP_DIASTOLIC',
	nodeType: functionNodeTypes.BPDiastolic,
	evaluate(node, evaluateExpr) {
		if (node.arguments.length !== 1) {
			return err(evaluatorErrorWithNode('Diastolic BP function expects exactly one argument', node))
		}
		const result = evaluateExpr(node.arguments[0])
		if (result.isErr()) return err(result.error)
		if (typeof result.value !== 'string' && result.value !== null) return ok(null)
		return ok(parseBPDiastolic(result.value as string | null))
	}
}
export const BPIsElevatedFunction: HelperFunction = {
	tokenName: 'BP_IS_ELEVATED',
	nodeType: functionNodeTypes.BPIsElevated,
	evaluate(node, evaluateExpr) {
		if (node.arguments.length !== 1) {
			return err(evaluatorErrorWithNode('BP IsElevated function expects exactly one argument', node))
		}
		const result = evaluateExpr(node.arguments[0])
		if (result.isErr()) return err(result.error)
		if (typeof result.value !== 'string' && result.value !== null) return ok(null)
		const value = result.value as string | null
		const sbp = parseBPSystolic(value)
		const dbp = parseBPDiastolic(value)
		if (sbp === null || dbp === null) return ok(null)
		return ok(sbp > 139 || dbp > 89)
	}
}
